import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsFeaturesRoute: InvariantJiraRoute = {
	name: 'plan-settings-features',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features',
};
